import React from "react";

function SwitchInputField(props) {
  return (
    <props.tag
      className={`${
        props.tagClass ? props.tagClass : "py-3 border-b border-slate-200"
      }`}
    >
      <div className="flex justify-between items-center">
        <div>
          <div className="text-slate-800 font-semibold">{props.title}</div>
          <div className={`text-sm + ${props?.wrapperCSS}`}>
            {props.description}
          </div>
        </div>
        <div className="flex items-center ml-4">
          <div className="text-sm text-slate-400 italic mr-2">
            {props.checked ? "On" : "Off"}
          </div>
          <div className="form-switch">
            <input
              type="checkbox"
              name={props.name}
              checked={props.checked}
              onChange={props.onCheck}
              id={"comments" + props.index}
              className="sr-only"
              disabled={props.disabled}
            />
            <label htmlFor={"comments" + props.index} className="bg-slate-400">
              <span className="bg-white shadow-sm" aria-hidden="true"></span>
              <span className="sr-only">
                {props.tooltip + " " + props.title}
              </span>
            </label>
          </div>
        </div>
      </div>
      {props.content}
    </props.tag>
  );
}

SwitchInputField.defaultProps = {
  tag: "div",
  name: "",
  tooltip: "Enable / disable",
  content: "",
};
export default SwitchInputField;
